import { useMatches } from 'react-router-dom';
import { RouteMatchShape } from '@/core/routes/routes.types';

export default function useHeader() {
  const matches = useMatches() as RouteMatchShape[];

  const header = matches
    .filter((match) => Boolean(match.handle?.header))
    .map((match) => match.handle.header)
    .pop();

  return header;
}
